module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAMCAYAAACJOyb4AAAA80lEQVQ4jWO8dPX2fwYaARbilX5kWPdqI8P8PzCdBgwzxPQYpCk3HGowqwPDZjE5op3DRIyip58PQQwWJN5gIg3/yHDy+3sGZw7SDAYBIoLlI8OjP4IMcgyXGAqfXWC4AxV1FoxjKOCk1PA/HxgeMrxn2PtZnmGGVBwkAr8fZvB9v5lBjtWXIQiPCUSFOQODIEOiEFLK4NRjSGR5z3D4+0e8uog0HB3wM8iwElZF2HAWeQZboCsf/UYW/MjwBMiXZ+Gn0HCgK805BRn2vj/McAoqAk6afxQZrAhEKCOx2f/p580MGZ/fQ3mKDLVStgxmBPQAADQrR0n8hmJmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwpstb6.png
// module id = 673
// module chunks = 0